import { Link } from "react-router-dom";
import { RubyShield } from "./EthicsImage";
import { useSEO } from "@/lib/useSEO";
import { DisciplineSwitcher } from "@/components/academy/DisciplineSwitcher";

export default function EthicsFrame({ title, crumb, children, testid, canonicalPath = "", draftGuard }) {
  useSEO({
    title: `${title} | Stoic Ethics | StoicOs.ai Academy`,
    canonical: `https://stoicos.ai/academy/ethics${canonicalPath}`,
  });
  return (
    <main className="min-h-screen bg-ink px-6 sm:px-10 py-24" data-testid={testid}>
      <div className="max-w-4xl mx-auto">
        <DisciplineSwitcher active="ethics" draftGuard={draftGuard} />
        <nav aria-label="Breadcrumb" className="text-[10px] tracking-[0.25em] uppercase text-[#c86058] mb-10">
          <Link to="/academy" className="hover:text-gold">Academy</Link> / <Link to="/academy/ethics" className="hover:text-gold">Stoic Ethics</Link> / <span className="text-fog">{crumb || title}</span>
        </nav>
        <div className="flex items-center gap-4 mb-8"><RubyShield size={36} /><h1 className="font-serif text-3xl sm:text-4xl text-bone">{title}</h1></div>
        {children}
      </div>
    </main>
  );
}
